var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"text-left text-break w-2"},[_c('a',{attrs:{"href":`/gb/service_titan/jobs/${_vm.row.id}`}},[_vm._v(_vm._s(_vm.row.id))])]),_vm._v(" "),_c('td',{staticClass:"text-left text-break w-8"},[_c('a',[_vm._v(_vm._s(_vm.row.summary))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }